(() => {
  // Shopify's header sign-in affordance is optional; keep guest chat approachable.
  // Scope the style to the chat runtime, leaving required authentication flows intact.
  const hideOptionalChatSignIn = () => {
    document.querySelectorAll('shopify-chat').forEach((chat) => {
      const root = chat.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
      if (!root || root.querySelector('#lure-chat-guest-header')) return;

      const style = document.createElement('style');
      style.id = 'lure-chat-guest-header';
      style.textContent = '.panel__header .panel__sign-in { display: none !important; }';
      root.appendChild(style);
    });
  };

  document.addEventListener('shopify-render', hideOptionalChatSignIn);
  hideOptionalChatSignIn();

  const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  let loaded = false;

  const appendScript = (src, selector) => {
    if (document.querySelector(selector)) return;

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  };

  const cleanup = () => {
    interactionEvents.forEach((eventName) => window.removeEventListener(eventName, loadApps));
  };

  const loadApps = () => {
    if (loaded) return;

    loaded = true;
    cleanup();

    if (window.Shopify?.shop) {
      const laybuyUrl = new URL('https://lay-buys.com/js/laybuy-advertize-element-creator-new.js');
      laybuyUrl.searchParams.set('shop', window.Shopify.shop);
      laybuyUrl.searchParams.set('t', Date.now().toString());
      appendScript(laybuyUrl.toString(), 'script[src*="laybuy-advertize-element-creator-new.js"]');
    }
  };

  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, loadApps, { once: true, passive: true });
  });

  window.setTimeout(loadApps, 30_000);
})();
